export enum ParametersRequestStatusAction {
  Load = '[Parameters] [Request Status] Load',
  Success = '[Parameters] [Request Status] Success',
  Error = '[Parameters] [Request Status] Error',
}
